import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["image", "title", "message", "searchText", "linkHref"];
import React from 'react';
import { Link } from '@gravity-ui/uikit';
import { Illustration } from '../Illustration/Illustration';
import { StubScreen } from './StubScreen';
import i18n from './i18n';
import './StubScreen.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function StubScreenNoResults(_ref) {
  var image = _ref.image,
    title = _ref.title,
    message = _ref.message,
    searchText = _ref.searchText,
    linkHref = _ref.linkHref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var stubProps = {
    image: image !== null && image !== void 0 ? image : /*#__PURE__*/_jsx(Illustration, {
      name: 'no-results',
      width: 200
    }),
    title: title !== null && title !== void 0 ? title : i18n('not_found'),
    message: message !== null && message !== void 0 ? message : /*#__PURE__*/_jsxs(_Fragment, {
      children: [i18n('items_not_found', {
        text: searchText
      }), /*#__PURE__*/_jsx("br", {}), i18n('try_another_query'), /*#__PURE__*/_jsx(Link, {
        href: linkHref,
        children: i18n('to_search_page')
      })]
    }),
    linkHref: ''
  };
  if (message && linkHref) {
    stubProps.linkHref = linkHref;
  }
  return /*#__PURE__*/_jsx(StubScreen, _objectSpread(_objectSpread({
    type: "no-results"
  }, stubProps), otherProps));
}
// #sourceMappingURL=StubScreenNoResults.js.map